// Regras puras da tela Histórico de chamadas (/call-historicals).
// Ficam fora do componente para poderem ser testadas sem renderizar nada.
import { i18n } from "../../translate/i18n";
import { AEROS } from "../../styles/aerosTokens";

// Status devolvidos pela Wavoip. A chave desconhecida cai em "neutral" com o
// texto cru, para nunca esconder do usuário um estado novo da API.
const STATUS = {
  ENDED: { key: "ended", color: AEROS.success, state: "success" },
  ACTIVE: { key: "active", color: AEROS.cyan, state: "info" },
  RINGING: { key: "ringing", color: AEROS.warning, state: "warning" },
  BUSY: { key: "busy", color: "#FB923C", state: "warning" },
  NO_ANSWER: { key: "noAnswer", color: "#9CA3B8", state: null },
  REJECTED: { key: "rejected", color: AEROS.error, state: "error" },
};

export const statusInfo = (status) => {
  const achado = STATUS[status];
  if (!achado) {
    return {
      label: status || i18n.t("aeros.calls.status.unknown"),
      color: "#9CA3B8",
      state: null,
    };
  }
  return {
    label: i18n.t(`aeros.calls.status.${achado.key}`),
    color: achado.color,
    state: achado.state,
  };
};

// A Wavoip chama a chamada de saída de "OUTCOMING" (sem o G, é assim mesmo
// no payload dela).
export const tipoInfo = (direction) => {
  const saida = direction === "OUTCOMING";
  return {
    saida,
    label: i18n.t(saida ? "aeros.calls.type.out" : "aeros.calls.type.in"),
    color: saida ? AEROS.cyan : "#C08BFF",
  };
};

// Duração em segundos → "mm:ss". Sem duração (chamada rejeitada, ocupada)
// devolve o travessão, que a tela pinta em tom apagado.
export const formataDuracao = (segundos) => {
  const total = Number(segundos);
  if (!Number.isFinite(total) || total <= 0) return "—";
  const min = Math.floor(total / 60);
  const seg = Math.floor(total % 60);
  return `${min}:${String(seg).padStart(2, "0")}`;
};

export const formataTelefone = (phone) => {
  if (!phone) return "—";
  const so = String(phone).replace(/\D/g, "");
  if (so.startsWith("55") && (so.length === 12 || so.length === 13)) {
    const ddd = so.slice(2, 4);
    const resto = so.slice(4);
    const corte = resto.length === 9 ? 5 : 4;
    return `+55 ${ddd} ${resto.slice(0, corte)}-${resto.slice(corte)}`;
  }
  return phone;
};

export const formataDataHora = (valor) => {
  if (!valor) return "—";
  const d = new Date(valor);
  if (Number.isNaN(d.getTime())) return "—";
  const p = (n) => String(n).padStart(2, "0");
  return `${p(d.getDate())}/${p(d.getMonth() + 1)} ${p(d.getHours())}:${p(
    d.getMinutes()
  )}`;
};

export const iniciais = (nome = "") =>
  String(nome)
    .split(" ")
    .filter(Boolean)
    .slice(0, 2)
    .map((p) => p[0])
    .join("")
    .toUpperCase();

// Chamada recebida costuma chegar sem nome de contato; o rótulo genérico
// evita a linha "N/A" que a tela antiga mostrava.
export const nomeChamada = (call) => {
  if (call?.name) return call.name;
  return call?.devices?.direction === "INCOMING"
    ? i18n.t("aeros.calls.incomingCall")
    : i18n.t("aeros.calls.unnamed");
};

// Só os quatro números que o backend já devolve. "Duração média" e filtro de
// período estão no mockup mas exigem backend novo — anotados, não inventados.
export const kpisChamadas = (stats = {}) => [
  { key: "total", value: Number(stats.total) || 0, color: AEROS.cyan },
  { key: "served", value: Number(stats.totalServed) || 0, color: AEROS.success },
  { key: "rejected", value: Number(stats.totalReject) || 0, color: AEROS.error },
  { key: "finished", value: Number(stats.totalFinish) || 0, color: AEROS.warning },
];
